import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); } catch { /* generic */ }
    setSent(true); setBusy(false);
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <p className="text-sm text-slate-600">If that email is registered, a reset link has been sent. Please check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" required />
          <Button data-testid="forgot-submit-button" type="submit" disabled={busy} className="w-full bg-medorange hover:bg-medorange-hover">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-xs text-slate-400 hover:text-navy"><ArrowLeft className="h-3 w-3" /> Back to sign in</Link>
    </AuthShell>
  );
}
